type PendoIdentity = {
  visitor?: { id: string };
  account?: { id: string };
};

type PendoAgent = {
  teardown?: () => void;
  _q: unknown[][];
};

declare global {
  interface Window {
    pendo?: PendoAgent;
  }
}

let hasInitialized = false;

export const initPendo = (
  appKey: string,
  visitorId?: string,
  accountId?: string,
): void => {
  if (hasInitialized || !appKey) {
    return;
  }
  hasInitialized = true;

  const identity: PendoIdentity = {};
  if (visitorId) {
    identity.visitor = { id: visitorId };
  }
  if (accountId) {
    identity.account = { id: accountId };
  }

  window.pendo = { _q: [['initialize', identity]] };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://cdn.pendo.io/agent/static/${appKey}/pendo.js`;
  document.head.appendChild(script);
};

export const teardownPendo = (): void => {
  window.pendo?.teardown?.();
  hasInitialized = false;
};
